import { styled } from '@clickcease/cc-client-components-lib'

export const GetTagInstructionsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
})

export const LogicalBlock = styled('div', {
  marginBottom: '24px',
})

export const LineSeparator = styled('div', {
  marginBottom: '12px',
})

export const CopyKeyContainer = styled('span', {
  display: 'flex',
  '> button': {
    marginLeft: '8px',
  },
})

export const GetTagInstructionsBulletContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  ':first-child': {
    marginInlineEnd: '8px',
  },
})

export const BulletPoint = styled('span', {
  width: '6px',
  minWidth: '6px',
  height: '6px',
  minHeight: '6px',
  borderRadius: '50%',
  backgroundColor: 'black',
})

export const GetTagInstructionsText = styled('span', {
  fontSize: '$md',
  fontWeight: 300,
  color: '$mainTextColor',
})

export const CodeBlock = styled('p', {
  border: '1px dashed rgba(155, 155, 155, 1)',
  borderRadius: '4px',
  fontWeight: 300,
  fontSize: '$sm',
  background: '$tableHovered',
  color: 'rgba(40, 36, 33, 1)',
  padding: '8px 12px',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
})

export const CodeSpan = styled('p', {
  border: '1px dashed rgba(155, 155, 155, 1)',
  borderRadius: '4px',
  fontWeight: 300,
  fontSize: '$sm',
  background: '$tableHovered',
  color: 'rgba(40, 36, 33, 1)',
  padding: '6px 12px',
  whiteSpace: 'pre-wrap',
  display: 'inline-block',
  marginInlineEnd: '10px',
})

export const EmailDeveloperContainer = styled('div', {
  width: '350px',
  gap: '$4',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
})

export const EmailErrorContainer = styled('div', {
  bottom: '-50px',
  position: 'absolute',
  display: 'flex',
  alignItems: 'flex-start',
  width: '300px',
  height: '50px',
})

export const EmailError = styled('div', {
  color: '$error',
  fontWeight: '$l',
  fontSize: '$md',
})

export const BoldBulletPoint = styled('span', {
  fontWeight: '$b',
  fontSize: '$lg',
})

export const Row = styled('div', {
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  overflow: 'auto',
  gap: '$4',
})

export const Column = styled('span', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
})

export const InfoIconContainer = styled('div', {
  paddingTop: '2px',
  width: '12px',
  height: '14px',
  color: '$neutral',
})

export const VerticalSeparator = styled('div', {
  width: '1px',
  height: '230px',
  backgroundColor: '$lightNeutral',
  marginInline: '$8',
})

export const GtmLeftSetion = styled('div', {
  width: '250px',
})

export const GtmScrollInstruction = styled('div', {
  height: '250px',
  overflow: 'scroll',

  '&::-webkit-scrollbar': {
    '-webkit-appearance': 'none',
    width: '7px',
  },

  '&::-webkit-scrollbar-thumb': {
    borderRadius: '4px',
    backgroundColor: 'rgba(0,0,0,.5)',
    '-webkit-box-shadow': '0 0 1px rgba(255,255,255,.5)',
  },
})

export const WordpressKeysContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginTop: '$8',
})
